export const GLOBAL_LOADING = 'GLOBAL_LOADING';
export const GLOBAL_LOADING_DONE = 'GLOBAL_LOADING_DONE';
export const LOADING_MUTATIONS_DONE = 'LOADING_MUTATIONS_DONE';
export const LOADING_MUTATIONS = 'LOADING_MUTATIONS';

export const CREATE_TICKET = 'CREATE_TICKET';
export const CREATE_TERMINAL = 'CREATE_TERMINAL';
export const CREATE_ACCOUNT = 'CREATE_ACCOUNT';
export const CREATE_WALLET = 'CREATE_WALLET';
export const CREATE_PAYMENT_FORM = 'CREATE_PAYMENT_FORM';
export const CREATE_SETTLEMENT = 'CREATE_SETTLEMENT';
export const CREATE_PAYMENT_FORM_QR_CODE = 'CREATE_PAYMENT_FORM_QR_CODE';
export const CREATE_BRANCH = 'CREATE_BRANCH';

export const GET_USERS = 'GET_USERS';
export const GET_PROFILE = 'GET_PROFILE';
export const GET_TERMINALS = 'GET_TERMINALS';
export const GET_FORMS = 'GET_FORMS';
export const GET_ACCOUNTS = 'GET_ACCOUNTS';
export const GET_WALLETS = 'GET_WALLETS';
export const GET_BRANCHES = 'GET_BRANCHES';
export const GET_TRANSACTIONS = 'GET_TRANSACTIONS';
export const GET_EXTRA_TRANSACTION_ITEMS = 'GET_EXTRA_TRANSACTION_ITEMS';
export const GET_TICKETS = 'GET_TICKETS';
export const GET_TICKET_PROFILE = 'GET_TICKET_PROFILE';
export const GET_USER_SERVICES = 'GET_USER_SERVICES';
export const GET_TICKET_COMMENTS = 'GET_TICKET_COMMENTS';
export const GET_NOTFICATION = 'GET_NOTFICATION';
export const GET_USER_SETTLEMENT_CONTRACTS = 'GET_USER_SETTLEMENT_CONTRACTS';
export const GET_USER_INFO = 'GET_USER_INFO';
export const GET_SETTLEMENTS = 'GET_SETTLEMENTS';
export const GET_TERMINAL_CONTRACTS = 'GET_TERMINAL_CONTRACTS';
export const GET_PAYMENT_FORM_CONTRACTS = 'GET_PAYMENT_FORM_CONTRACTS';
export const GET_DASHBOARD = 'GET_DASHBOARD';
export const GET_LAST_DEPOSITS = 'GET_LAST_DEPOSITS';
export const GET_LAST_SETTLEMENTS = 'GET_LAST_SETTLEMENTS';
export const GET_TRANSACTIONS_CHART = 'GET_TRANSACTIONS_CHART';
export const GET_USER_PROFILE = 'GET_USER_PROFILE';
export const GET_USER_AUTH = 'GET_USER_AUTH';
export const GET_PUBLIC_NOTIFICATIONS = 'GET_PUBLIC_NOTIFICATIONS';
export const GET_BRANCH = 'GET_BRANCH';
export const GET_EFFECTIVE_DATES = 'GET_EFFECTIVE_DATES';
export const GET_AFFILIATES = 'GET_AFFILIATES';
export const GET_COMMISSION_BACK = 'GET_COMMISSION_BACK';
export const GET_TERMINAL_NAMES = 'GET_TERMINAL_NAMES';
export const GET_SINGLE_FORM = 'GET_SINGLE_FORM';
export const GET_ALL_TRANSACTIONS = 'GET_ALL_TRANSACTIONS';
export const GET_BRANCH_NAMES = 'GET_BRANCH_NAMES';

export const CLEAR_NEW_TERMINAL_INPUT = 'CLEAR_NEW_TERMINAL_INPUT';
export const CLEAR_UPDATE_EXTRA_FIELD = 'CLEAR_UPDATE_EXTRA_FIELD';
export const CLEAR_NEW_EXTRA_FIELD = 'CLEAR_NEW_EXTRA_FIELD';
export const CLEAR_AUTH = 'CLEAR_AUTH';
export const CLEAR_CHART = 'CLEAR_CHART';
export const CLEAR_PUBLIC_NOTIFICATIONS = 'CLEAR_PUBLIC_NOTIFICATIONS';
export const CLEAR_AUTHENTICATION = 'CLEAR_AUTHENTICATION';
export const CLEAR_FORMS = 'CLEAR_FORMS';
export const CLEAR_TERMINALS = 'CLEAR_TERMINALS';
export const CLEAR_WALLETS = 'CLEAR_WALLETS';
export const CLEAR_ACCOUNTS = 'CLEAR_ACCOUNTS';
export const CLEAR_ALL_TRANSACTIONS = 'CLEAR_ACCOUNTS';
export const CLEAR_SETTLEMENTS = 'CLEAR_SETTLEMENTS';
export const CLEAR_TRANSACTIONS_FILTER = 'CLEAR_TRANSACTIONS_FILTER';
export const CLEAR_TRANSACTIONS_WITHOUT_FILTERS = 'CLEAR_TRANSACTIONS_WITHOUT_FILTERS';
export const CLEAR_TRANSACTIONS_WITH_FILTERS = 'CLEAR_TRANSACTIONS_WITH_FILTERS';
export const CLEAR_USER_INFO = 'CLEAR_USER_INFO';
export const CLEAR_NOTFICATION = 'CLEAR_NOTFICATION';
export const CLEAR_SETTLEMENTS_WITH_FILTERS = 'CLEAR_SETTLEMENTS_WITH_FILTERS';
export const CLEAR_SETTLEMENTS_WITHOUT_FILTERS = 'CLEAR_SETTLEMENTS_WITHOUT_FILTERS';
export const CLEAR_TICKETS = 'CLEAR_TICKETS';
export const CLEAR_DASHBOARD = 'CLEAR_DASHBOARD';
export const CLEAR_EXTRA_TRANSACTION_ITEMS = 'CLEAR_EXTRA_TRANSACTION_ITEMS';
export const CLEAR_AFFILIATION = 'CLEAR_AFFILIATION';
export const CLEAR_COMMISSION_BACK = 'CLEAR_COMMISSION_BACK';
export const CLEAR_USER_SERVICES = 'CLEAR_USER_SERVICES';
export const CLEAR_FORM_ACTION = 'CLEAR_FORM_ACTION';
export const CLEAR_BRANCHES = 'CLEAR_BRANCHES';
export const CLEAR_PAYMENT_FORM_QR_CODE = 'CLEAR_PAYMENT_FORM_QR_CODE';
export const CLEAR_MESSAGE_WALLET_TRANSACTIONS = 'CLEAR_MESSAGE_WALLET_TRANSACTIONS';

export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_TERMINAL = 'UPDATE_TERMINAL';
export const UPDATE_TERMINAL_CONFIG = 'UPDATE_TERMINAL_CONFIG';
export const UPDATE_PAYMENT_FORM = 'UPDATE_PAYMENT_FORM';
export const UPDATE_EXTRA_FIELD = 'UPDATE_EXTRA_FIELD';
export const UPDATE_WALLET = 'UPDATE_WALLET';
export const UPDATE_NOTFICATION = 'UPDATE_NOTFICATION';
export const UPDATE_BRANCH = 'UPDATE_BRANCH';
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export const UPDATE_USER_SERVICES = 'UPDATE_USER_SERVICES';

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const USER_LOADED = 'USER_LOADED';
export const SHOW_ALERT = 'SHOW_ALERT';
export const SWITCH_TOMAN = 'SWITCH_TOMAN';
export const BRANCH_MODAL = 'BRANCH_MODAL';

export const EDIT_MODAL = 'EDIT_MODAL';
export const MODAL_DONE = 'MODAL_DONE';
export const MODAL_FORM_QR = 'MODAL_FORM_QR';
export const MODAL_SEND_MESSAGE = 'MODAL_SEND_MESSAGE';
export const FORM_ACTION = 'FORM_ACTION';
export const OPEN_EDIT = 'OPEN_EDIT';
export const CLOSE_EDIT = 'CLOSE_EDIT';

export const NEW_TERMINAL_INPUT = 'NEW_TERMINAL_INPUT';
export const NEW_EXTRA_FIELD = 'NEW_EXTRA_FIELD';

export const DELETE_WALLET = 'DELETE_WALLET';

export const UPLOAD_ACTIVE_TERMINAL = 'UPLOAD_ACTIVE_TERMINAL';
export const SWITCH_SKIN = 'SWITCH_SKIN';

export const AUTHENTICATION_LOGIN = 'AUTHENTICATION_LOGIN';
export const TRANSACTIONS_FILTER = 'TRANSACTIONS_FILTER';
export const SETTLEMENTS_FILTER = 'SETTLEMENTS_FILTER';
export const LOGIN_AS_BRANCH = 'LOGIN_AS_BRANCH';
export const REGISTER = 'REGISTER';
export const ACTIVATE_USER = 'ACTIVATE_USER';
export const AUTHENTICATE_USER = 'AUTHENTICATE_USER';
export const AUTHENTICATE_TELEPHONE = 'AUTHENTICATE_TELEPHONE';

export const FORGET_PASSWORD = 'FORGET_PASSWORD';
export const LOGIN_TYPE = 'LOGIN_TYPE';
export const COMPLETE_TRANSACTIONS = 'COMPLETE_TRANSACTIONS';
export const SHOW_NOTIFICATIONS = 'SHOW_NOTIFICATIONS';
export const SHOW_APPLICATION_SUGGEST = 'SHOW_APPLICATION_SUGGEST';
export const HIDE_APPLICATION_SUGGEST = 'HIDE_APPLICATION_SUGGEST';
export const SHOW_CONFIRM_SETTLE_MODAL = 'SHOW_CONFIRM_SETTLE_MODAL';
export const HIDE_CONFIRM_SETTLE_MODAL = 'HIDE_CONFIRM_SETTLE_MODAL';
export const PAYMENT_FORM_INPUT = 'PAYMENT_FORM_INPUT';
export const TRANSFER_MONEY = 'TRANSFER_MONEY';

export const CHART_LOADING_DONE = 'CHART_LOADING_DONE';
export const CANCEL_SETTLEMENT = 'CANCEL_SETTLEMENT';
export const TWO_STEP_LOGIN = 'TWO_STEP_LOGIN';
export const SET_CODE_INPUT = 'SET_CODE_INPUT';
export const SET_CODE_INPUT_DOWN = 'SET_CODE_INPUT_DOWN';

export const READ_NOTIFICATION = 'READ_NOTIFICATION';
export const CHARGE_SIMPLE_MESSAGE_WALLET = 'CHARGE_SIMPLE_MESSAGE_WALLET';

export const VERIFY_TFA = 'VERIFY_TFA';
export const VERIFY_MESSAGING_CHARGE = 'VERIFY_MESSAGING_CHARGE';
export const FORGET_PASS_INPUT = 'FORGET_PASS_INPUT';
export const SET_USER_BRANCH_INFO = 'SET_USER_BRANCH_INFO';
export const SEND_MERCHANT_IBAN = 'SEND_MERCHANT_IBAN';
export const SEND_PAYMENT_FORM_SMS = 'SEND_PAYMENT_FORM_SMS';
export const SEND_PAYMENT_FORM_WHATSAPP = 'SEND_PAYMENT_FORM_WHATSAPP';
export const DELETE_BRANCH_CONFIRMATION = 'DELETE_BRANCH_CONFIRMATION';
export const GET_MESSAGE_WALLET_TRANSACTIONS = 'GET_MESSAGE_WALLET_TRANSACTIONS';
